module.exports = __webpack_public_path__ + "img/image-(4).0a904002.jpg";